import VSelectStudentUpdateType from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectStudentUpdateType', VSelectStudentUpdateType),
};
